import { NotImplemented } from 'components';
import { QuizSessionOverview_quiz_master_quiz_session_quiz_session_user_progresses as UserSessions } from 'graphql/subscriptions/types/QuizSessionOverview';

interface Props {
    userSessions: UserSessions[];
}

export const SlideshowDistributedOverview = (props: Props) => {
    return <NotImplemented />;
};
